module.exports = __webpack_public_path__ + "static/img/marketingTo.cdce338.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weChat/marketingTo.png
// module id = vN2q
// module chunks = 0